module.exports = __webpack_public_path__ + "img/cartoonHead3-2.37052374.png";